<script>
import { event } from "vue-analytics";
import { mapState, mapGetters, mapActions } from "vuex";
import NewAddress from "./NewAddress/Index";
import EditAddress from "./EditAddress";
import AddressCard from "./Address";
import Confirmation from "@/components/_Shared/Confirmation";

export default {
  props: {
    selected: {
      required: false,
      default: null
    }
  },

  data() {
    return {
      newAddress: false,
      editAddress: false,
      confirmDelete: false,
      preloader: false,
      editable: false,
      destroyable: false,
      addresses: []
    };
  },

  components: {
    EditAddress,
    NewAddress,
    AddressCard,
    Confirmation
  },

  computed: {
    ...mapState("user", ["user"])
  },

  methods: {
    ...mapActions("addresses", ["getByUser", "destroy"]),

    async getAll() {
      try {
        this.addresses = await this.getByUser();
      } catch (e) {}
    },

    deleteConfirmation(address) {
      this.destroyable = address;
      this.confirmDelete = true;
    },

    showEdit(address) {
      this.$emit("selected", null);
      this.editable = address;
      this.editAddress = true;
    },

    async destroyAddress() {
      this.preloader = true;

      try {
        await this.destroy(this.destroyable.id);
        this.destroyable = null;
        this.confirmDelete = false;
        this.refresh();
      } catch (e) {
        this.$toasted.error(e);
      }

      this.preloader = false;
    },

    sendEvent(name, address = false) {
      event("cliente", "click", this.getEventName(name));
    },

    setSelected(address) {
      this.sendEvent("selecionou o endereco", address);
      this.$emit("selected", address);
    },

    async updated(address) {
      this.editAddress = false;
      await this.refresh();
      this.setSelected(address);
    },

    async refresh() {
      this.setSelected(null);
      await this.getAll();
    },

    showNewAddress() {
      this.sendEvent("clicou em adicionar endereco");
      this.$emit("selected", null);
      this.newAddress = true;
    },

    getEventName(event) {
      return this.$route.name === "purchase-flow"
        ? `Compra:Endereco:${event}`
        : `Endereco:${event}`;
    },

    async createdAddress(newAddress) {
      await this.refresh();
      const address = this.addresses.find(el => el.id === newAddress.id);
      this.setSelected(address);
    },

    selectSingleAddress() {
      if (this.hasSingleAddress()) {
        this.setSelected(this.addresses[0]);
        return true;
      }

      return false;
    },

    showCreateNewAddress() {
      if (this.addresses.length === 0) {
        return this.showNewAddress();
      }
    },

    hasSingleAddress() {
      return this.addresses.length === 1;
    }
  },

  async created() {
    await this.getAll();
    if (!this.selectSingleAddress()) {
      this.showCreateNewAddress();
    }
  }
};
</script>

<template>
  <div class="section">
    <address-card
      v-for="address in addresses"
      :key="address.id"
      :address="address"
      :selected="selected && selected.id === address.id"
      @delete="deleteConfirmation"
      @edit="showEdit"
      @selected="setSelected"
    />

    <div class="new-address" @click="showNewAddress">
      <div class="icon-plus">+</div>
      <span>adicionar endereço</span>
    </div>

    <new-address
      v-if="newAddress"
      :user="{type: user.accountable.type, id: user.accountable.id}"
      @close="newAddress = false"
      @created="createdAddress($event)"
    />

    <edit-address
      v-if="editAddress"
      :address="editable"
      @close="editAddress = false"
      @updated="updated"
    />
  </div>
</template>

<style scoped>
.section {
  margin: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
}

.new-address {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  width: 180px;
  margin: 10px;
  font-size: 12px;
  cursor: pointer;
  user-select: none;
}

.new-address span {
  font-weight: 600;
  color: var(--purple);
  text-transform: uppercase;
  text-align: center;
}

.icon-plus {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 40px;
  background-color: var(--purple);
  border-radius: 100%;
  margin-bottom: 10px;
}

@media (max-width: 480px) {
  .new-address {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Addresses/Index.vue